import clsx from 'clsx';
import { SeoPlpType } from 'lib/apis/services/SeoPlp';
import groupBy from 'lodash/groupBy';
import has from 'lodash/has';
import toArray from 'lodash/toArray';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useState } from 'react';

interface Props extends Partial<SeoPlpType.SEOResult> {}

function RelatedLink(props: Props) {
  const { t } = useTranslation(['common'], {
    bindI18n: 'languageChanged loaded',
  });

  const relatedLink = props?.links;
  const [open, setOpen] = useState(false);
  return (
    <>
      <section
        className={clsx(
          'transition-all h-auto ease-in-out duration-[1000ms] max-h-56 overflow-y-clip',
          {
            '!max-h-[4000px]': open,
          }
        )}
      >
        <h2 className="p-2 mb-2 -m-2 font-bold bg-gray-300 rounded-t-lg">
          {has(props, 'locationTitle')
            ? t('plp.relatetLink.title', props)
            : t('plp.relatetLink.titleWithoutTitle')}
        </h2>
        <div className="flex flex-col border-b border-b-grey-300">
            <ul
              className="flex flex-col py-2 space-y-2 border-b last:mb-0 border-b-grey-300 last:border-none"
            >
              {!!relatedLink && relatedLink.map((link, linkIndex) => (
                <li key={`${link.url}_${linkIndex}`}>
                  <h3 className="text-sm">
                    <Link
                      href={`/${link.url}`}
                      prefetch={false}
                      target="_blank"
                      as={`/${link.url}`}
                    >
                      <a
                        target="_blank"
                        className="hover:underline underline-offset-4"
                      >
                        {link.title}
                      </a>
                    </Link>
                  </h3>
                </li>
              ))}
            </ul>
        </div>

        <div
          className="mt-2 locationDescription "
          dangerouslySetInnerHTML={{
            __html: props.locationDescription || '',
          }}
        ></div>
      </section>
      <div className="flex items-center justify-center">
        <span
          className="w-full mt-4 text-center cursor-pointer text-primary-600 hover:underline"
          onClick={() => setOpen((state) => !state)}
        >
          {open ? t('global.showLess') : t('global.showMore')}
        </span>
      </div>
    </>
  );
}

export default RelatedLink;
